exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activate{display:flex;flex-direction:column;padding-top:4.875rem;max-width:768px;margin:auto;margin-bottom:40px;padding:12px}.activate__heading{position:relative;margin-top:72px;margin-bottom:1rem;padding:0;font-size:24px;font-weight:400}@media(min-width: 64em){.activate__heading{margin-top:60px;font-size:32px}}.activate__byline{color:#4a4a4a;font-weight:400;margin-bottom:16px}", ""]);

// exports
